var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"record-number"},[_vm._v("Copyringht @ 2017-2024 All Rights Reserved. 深圳市布雷斯塔科技有限公司 "),_c('a',{staticStyle:{"color":"#aeaeae"},attrs:{"target":"_blank","href":"https://beian.miit.gov.cn/#/Integrated/index"}},[_vm._v("粤ICP备2024264095号 ")])])])])
}]

export { render, staticRenderFns }